import * as ng from 'angular';
import * as uib from 'angular-ui-bootstrap'
import * as _ from 'underscore';

import { editableFields } from '../../editable/experience-text.directive';

export const mockEmailFieldValues = {
   FirstName: '[First Name]',
   LastName: '[Last Name]',
   EventName: 'Sample Event',
   EventAddress: '2294 Southern Avenue',
   EventAddress2: '3rd Floor',
   EventCity: 'New York',
   EventState: 'NY',
   EventZip: '10001',
   EventDate: 'Sunday, Jan 01, 1900',
   EventTime: '08:00 PM',
   EventEndTime: '11:00 PM',
   EventHost: '[Event Host Name]',
   InviteeFirstName: 'Jane',
   InviteeLastName: 'Smith'
};

export class EmailTestDialogController {
   static $inject = ['$uibModalInstance', 'session'];

   fields:{key:string, detail:string, value:string}[];

   constructor(
      private $uibModalInstance:uib.IModalInstanceService,
      private session
   ) {
      this.fields = _.chain(editableFields.preregEmail)
         .filter(f => mockEmailFieldValues[f.key])
         .map(f => _.extend(f, { value: mockEmailFieldValues[f.key] }))
         .value();
   }

   get email() {
      return this.session.getUser().email;
   }

   send() {
      let mergeVars = _.reduce(this.fields, (obj, f) => {
         obj[f.key] = f.value;
         return obj;
      }, {});

      this.$uibModalInstance.close(mergeVars);
   }

   close() {
      this.$uibModalInstance.dismiss('cancel');
   }
}

ng.module('e360')
   .controller('EmailTestDialogController', EmailTestDialogController);

ng.module('e360')
   .factory('openEmailTestDialog', dialogOpenerFactory);

const emailTestDialog = {
   templateUrl: require('./email-test-dialog.html'),
   controller: 'EmailTestDialogController as ctrl'
};

dialogOpenerFactory.$inject = ['$uibModal'];
function dialogOpenerFactory($uibModal:uib.IModalService) {
   return function openEmailTestDialog() {
      return $uibModal.open(emailTestDialog).result;
   }
}
